module.exports = __webpack_public_path__ + "img/Mask Group 26.40d8cdf5.png";